module.exports = __webpack_public_path__ + "graphics/13.ckh.20296bae411a2041ba4deb3c5bef8bff.png";